<template>
    <nav class="nav-wrap">
        <div class="header-logo-wrap">
            <router-link to="/madmin/center/main">
                <img v-if="centerLogo" :src="centerLogo" alt="로고사진" class="header-logo" />
                <img v-else src="/img/logo-wide.png" alt="로고사진" class="header-logo" />
            </router-link>
        </div>
        <div class="nav-top">
            <span class="photo-area">
                <img alt="유저 사진" class="user-img nav-profile" src="/img/temp/img_profile_admin user.png" />
                <a class="setting-btn" href="#"><span class="blind">설정</span></a>
            </span>
            <span class="info-area">
                <div class="nav-profile-name">{{ userName }}</div>
                <div class="nav-profile-position">{{ roleName }}</div>
                <a class="btn-logout" href="#" @click.prevent="onClickLogout">로그아웃</a>
            </span>
        </div>
        <ul class="nav-items-wrap">
            <!-- <li :class="{ on: menuList[0] === '홈' }">
                <router-link to="/madmin/noti/basic" @click="changeState">
                    <div class="menu-item">
                        <img
                            :src="menuList[0] === '홈' ? '/img/ic_book_on.png' : '/img/ic_book_off.png'"
                            alt=""
                            class="nav-item-icon"
                        />
                        <span class="menu-text">홈</span>
                        <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" />
                    </div>
                </router-link>
            </li> -->
            <li :class="{ on: menuList[0] === '업체관리' }">
                <div class="menu-item menu-expand">
                    <!-- <img
                        :src="menuList[0] === '업체관리' ? '/img/ic_month_on.png' : '/img/ic_month_off.png'"
                        alt=""
                        class="nav-item-icon"
                    /> -->
                    <span class="menu-text">업체관리</span>
                    <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" />
                </div>
                <ul>
                    <li :class="{ on: menuList[1] === '센터관리' }">
                        <router-link to="/madmin/business/center/list">센터관리</router-link>
                    </li>
                    <li :class="{ on: menuList[1] === '계약관리' }">
                        <router-link to="/madmin/business/contract/list">계약관리</router-link>
                    </li>
                    <li :class="{ on: menuList[1] === '핏페이관리' }">
                        <router-link to="/madmin/business/fitpay/list">핏페이관리</router-link>
                    </li>
                    <li :class="{ on: menuList[1] === '체인점관리' }">
                        <router-link to="/madmin/business/chain/list">체인점관리</router-link>
                    </li>
                    <li :class="{ on: menuList[1] === 'SMS(문자메시지)' }">
                        <router-link to="/madmin/business/smsNumSetting">SMS(문자메시지)</router-link>
                    </li>
                </ul>
            </li>
            <li :class="{ on: menuList[0] === '알림톡발송' }">
                <router-link to="/madmin/noti/basic" @click="changeState">
                    <div class="menu-item">
                        <!-- <img
                            :src="menuList[0] === '알림톡발송' ? '/img/ic_book_on.png' : '/img/ic_book_off.png'"
                            alt=""
                            class="nav-item-icon"
                        /> -->
                        <span class="menu-text">알림톡발송</span>
                        <!-- <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" /> -->
                    </div>
                </router-link>
            </li>
            <li :class="{ on: menuList[0] === '매출관리' }">
                <div class="menu-item menu-expand">
                    <!-- <img
                        :src="menuList[0] === '매출관리' ? '/img/ic_month_on.png' : '/img/ic_month_off.png'"
                        alt=""
                        class="nav-item-icon"
                    /> -->
                    <span class="menu-text">매출관리</span>
                    <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" />
                </div>
                <ul>
                    <li :class="{ on: menuList[1] === '매출현황' }">
                        <router-link to="/madmin/sales/state/manager">매출현황</router-link>
                    </li>
                </ul>
            </li>
            <li :class="{ on: menuList[0] === '직원관리' }">
                <router-link to="/madmin/employee/list" @click="changeState">
                    <div class="menu-item">
                        <!-- <img
                            :src="menuList[0] === '직원관리' ? '/img/ic_book_on.png' : '/img/ic_book_off.png'"
                            alt=""
                            class="nav-item-icon"
                        /> -->
                        <span class="menu-text">직원관리</span>
                        <!-- <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" /> -->
                    </div>
                </router-link>
            </li>
            <li :class="{ on: menuList[0] === '권한설정' }">
                <router-link to="/madmin/author/list" @click="changeState">
                    <div class="menu-item">
                        <!-- <img
                            :src="menuList[0] === '권한설정' ? '/img/ic_book_on.png' : '/img/ic_book_off.png'"
                            alt=""
                            class="nav-item-icon"
                        /> -->
                        <span class="menu-text">권한설정</span>
                        <!-- <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" /> -->
                    </div>
                </router-link>
            </li>
            <li :class="{ on: menuList[0] === '팝업관리' }">
                <router-link to="/madmin/popup/list" @click="changeState">
                    <div class="menu-item">
                        <!-- <img
                            :src="menuList[0] === '팝업관리' ? '/img/ic_book_on.png' : '/img/ic_book_off.png'"
                            alt=""
                            class="nav-item-icon"
                        /> -->
                        <span class="menu-text">팝업관리</span>
                        <!-- <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" /> -->
                    </div>
                </router-link>
            </li>
            <li :class="{ on: menuList[0] === '광고관리' }">
                <router-link to="/madmin/setting/advertisement" @click="changeState">
                    <div class="menu-item">
                        <!-- <img
                            :src="menuList[0] === '광고관리' ? '/img/ic_book_on.png' : '/img/ic_book_off.png'"
                            alt=""
                            class="nav-item-icon"
                        /> -->
                        <span class="menu-text">광고관리</span>
                        <!-- <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" /> -->
                    </div>
                </router-link>
            </li>
            <!--
            <li :class="{'on': menuList[0] === '메시지'}">
                <button>메시지</button>
                <ul>
                    <li :class="{'on': menuList[1] === '메시지 발송'}"><a href="#">메시지 발송</a></li>
                    <li :class="{'on': menuList[1] === '발송내역'}"><a href="#">발송내역</a></li>
                    <li :class="{'on': menuList[1] === '메시지 내용설정'}"><a href="#">메시지 내용설정</a></li>
                    <li :class="{'on': menuList[1] === '충전내역 및 설정'}"><a href="#">충전내역 및 설정</a></li>
                </ul>
            </li>
            -->
        </ul>
        <ul class="nav-items-wrap">
            <li :class="{ on: menuList[0] === '공지사항' }">
                <router-link to="/madmin/notice/list" @click="changeState">
                    <div class="menu-item">
                        <img
                            :src="
                                menuList[0] === '공지사항'
                                    ? '/img/ic_notification_on.png'
                                    : '/img/ic_notification_off.png'
                            "
                            alt=""
                            class="nav-item-icon"
                        />
                        <span class="menu-text">공지사항</span>
                        <!-- <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" /> -->
                    </div>
                </router-link>
            </li>
            <li :class="{ on: menuList[0] === '자주하는 질문' }">
                <router-link to="/madmin/question/list" @click="changeState">
                    <div class="menu-item">
                        <img
                            :src="menuList[0] === '자주하는 질문' ? '/img/ic_chat_on.png' : '/img/ic_chat_off.png'"
                            alt=""
                            class="nav-item-icon"
                        />
                        <span class="menu-text">자주하는 질문</span>
                        <!-- <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" /> -->
                    </div>
                </router-link>
            </li>
            <li :class="{ on: menuList[0] === '사용자 매뉴얼' }">
                <router-link to="/madmin/manual/list" @click="changeState">
                    <div class="menu-item">
                        <img
                            :src="menuList[0] === '사용자 매뉴얼' ? '/img/ic_book_on.png' : '/img/ic_book_off.png'"
                            alt=""
                            class="nav-item-icon"
                        />
                        <span class="menu-text">사용자 매뉴얼</span>
                        <!-- <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" /> -->
                    </div>
                </router-link>
            </li>
            <li>
                <router-link to="/madmin/qna/list" @click="changeState">
                    <div class="menu-item">
                        <img
                            :src="menuList[0] === '1:1 문의하기' ? '/img/ic_chat_on.png' : '/img/ic_chat_off.png'"
                            alt=""
                            class="nav-item-icon"
                        />
                        <span class="menu-text">1:1 문의하기</span>
                        <!-- <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" /> -->
                    </div>
                </router-link>
            </li>
        </ul>
    </nav>
</template>

<script>
import jQuery from 'jquery';

export default {
    name: 'home',
    props: {
        propsSample: {
            type: Number,
            default: 0,
            required: false,
            validator(value) {
                return value >= 0;
            },
        },
    },
    computed: {
        menuList() {
            return this.$route.meta.gnbMenu;
        },
        roleName() {
            return this.authRoleName === '' ? '최고관리자' : this.authRoleName;
        },
        userName() {
            return this.authUserName === '' ? '핏투데이' : this.authUserName;
        },
    },
    data() {
        return {
            authRoleName: '',
            authUserName: '',
            // menuList: '',
        };
    },
    mounted() {
        this.authRoleName = this.$store.getters['auth/roleName'];
        this.authUserName = this.$store.getters['auth/userName'];

        // this.menuList = this.$route.meta.gnbMenu;

        /* 펼치기 */
        jQuery('.nav-items-wrap > li > .menu-expand').on('click', function slide() {
            jQuery('.nav-items-wrap > li > ul').not(jQuery(this)).stop().slideUp();
            jQuery(this).next('ul').stop().slideToggle();
        });
    },
    methods: {
        onClickLogout() {
            // LOGOUT 변이 실행 후 리다이렉트
            // this.$store.dispatch('auth/logout').then(() => this.$router.push('/login'));
            this.$store.dispatch('auth/logout');
            this.$router.push('/care/login');
        },
    },
};
</script>
<style lang="scss"></style>
